//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
import { angularFileUpload } from 'angular';
import { IAbortablePromise, IPromiseService } from 'pinsights-js-shared';

import { IUploadMediaToLibraryResponse } from '@apis/media-library/mediaLibraryApiModel';
import CollectionId from '@models/CollectionId';
import { RequestError, WebGatewayError } from '@utils/sessionFetch';

export class GatewayMediaUploadApiService {
  constructor(
    private readonly $upload: angularFileUpload.IUploadService,
    private readonly promiseService: IPromiseService,
  ) {}

  public uploadMediaToLibrary(
    media: File,
    collectionId?: CollectionId,
  ): IAbortablePromise<IUploadMediaToLibraryResponse> {
    return this.promiseService.processHttpResponse(
      this.$upload
        .upload<IUploadMediaToLibraryResponse>({
          url: `${CURALATE_ENV.WEB_GATEWAY_URL}/api/v1/media/library/add-by-bytes`,
          method: 'POST',
          data: { file: media },
          params: {
            collectionId,
          },
          headers: {
            'Upload-Length': media.size,
          },
        })
        .then(
          (x) => x,
          (e) => {
            const error = e as WebGatewayError;
            if ('msg' in error && error.msg) {
              throw new RequestError(error.msg, error.errorId);
            } else if ('error' in error && error.error.message) {
              throw new RequestError(error.error.message, error.error.errorId);
            }
            // Rethrow as-is if we can't identify the error type
            throw e;
          },
        ),
    );
  }
}

angular
  .module('curalate')
  .service('GatewayMediaUploadApiService', [
    '$upload',
    'PromiseService',
    GatewayMediaUploadApiService,
  ]);
